import React from 'react';
import { InitialItemQuantity, ItemQuantity } from './styled';

type Props = {
  quantity: number;
  refundedQuantity?: number;
};

const ItemQuantityWithRefundedQuantity: React.FC<Props> = ({
  quantity,
  refundedQuantity,
}) => (
  <>
    {refundedQuantity ? (
      <>
        <InitialItemQuantity>x{quantity}</InitialItemQuantity>
        <ItemQuantity>x{quantity - refundedQuantity}</ItemQuantity>
      </>
    ) : (
      <ItemQuantity>x{quantity}</ItemQuantity>
    )}
  </>
);

export default ItemQuantityWithRefundedQuantity;
